export default {
  alumnoCursado: { alumno: {} },
  alumnoCursados: [],
  fields: {},
  errorArray: [],
  dialog: false,
  pagination: {},
};
